const Info = ({ stroke = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
  >
    <circle cx="8" cy="8" r="6.5" stroke={stroke} strokeWidth="1.4" />
    <path
      d="M8 7v4M8 4.8v.4"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export default Info;
